import { api } from '@/f1/service';

//restful api
import { log } from '@/f1/service/api';

//i18n_data
import fields from './i18n_data'
import i18n_data from '@/component/i18n_data';

const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

export default {
  props : ['user_id'],
  data: () => ({ so : default_opt() }),
  computed: {
    rowCount() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() { return fields.i18n_fields[this.i18n] },
  },
  methods: {
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk || 'name,fqdn',
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // Build all
      // var search = { target : 'log.login', cmd : 'list.user', limit: so.pc, offset: (so.pg - 1) * so.pc, body: { and: [], or: [], sort: [] } }
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, body: { and: [], or: [], sort: [] } }
      // order
      if(so.ok) { search.body.sort.push({name: so.ok, op: so.od == 'd' && 'desc' }); }
      // user
      if(this.user_id) { search.body.and.push({ name: 'user_id', op: '=', value : this.user_id }); }
      // search
      if(so.sk && so.sv) {
        const value = so.sv.replace(/\*/g, '%');
        for(let key of so.sk.split(',')) {
          search.body.or.push({name: key, value: value, op: /%/.test(value) ? 'like' : '=' });
        }
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        switch(key) {
          case 'created_at_sd' : search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_ed' : search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          default: search.body.and.push({name: key, value: value.trim().replace(/\*/g, '%'), op: /[%\*]/.test(value) ? 'like' : '=' }); break;
        }
      }
      // try { let rs = await api.member.Manager(search); this.so.totalRows = rs.total; return rs.body; }
      try { let rs = await log.login.userList(search); this.so.totalRows = rs.total; return rs.body;}
      catch(e) { this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}` || e); }
    },
    detail(item) {
      // this.$router.push(`/log.login/${item.id}`);
    },
  },
  created() { console.log('[vue] log.login', 'created'); },
  destroyed() { console.log('[vue] log.login', 'destroyed'); },
  mounted() { console.log('[vue] log.login', 'mounted'); },
}
